import { NgSwitch, NgSwitchCase, TitleCasePipe } from '@angular/common';
import { Component, HostListener, Inject } from '@angular/core';
import { MatDialogContent, MatDialogRef, MatDialogTitle, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CandidateDuplicateDetailsComponent } from '../duplicate-details/candidate/candidate-duplicate-details.component';
import { CompanyDuplicateDetailsComponent } from '../duplicate-details/company/company-duplicate-details.component';
import { ContactDuplicateDetailsComponent } from '../duplicate-details/contact/contact-duplicate-details.component';
import { DuplicateTableEntry } from '../duplicate-table-entry';
import { Entity } from '../entity';

export interface IDuplicatesDialogData {
  mergingEntity: Entity;
  duplicateTableEntry: DuplicateTableEntry;
}

@Component({
  selector: 'app-duplicates-dialog',
  templateUrl: './duplicates-dialog.component.html',
  styleUrls: ['./duplicates-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    MatDialogContent,
    CandidateDuplicateDetailsComponent,
    ContactDuplicateDetailsComponent,
    CompanyDuplicateDetailsComponent,
    NgSwitch,
    NgSwitchCase,
    TitleCasePipe
  ]
})
export class DuplicatesDialogComponent {
  public readonly mergingEntity = Entity;

  constructor(
    public dialogRef: MatDialogRef<DuplicatesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: IDuplicatesDialogData) {
  }

  // Keyboard Shortcuts
  // - Use Escape to close the dialog
  @HostListener('document:keydown', ['$event'])
  protected handleKeydownEvent(event: KeyboardEvent) {
    if (event.code === 'Escape') {
      this.dialogRef.close();
    }
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
